import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'jump-button',
  styleUrl: 'jump-button.scss',
  shadow: true,
})
export class JumpButton {
  /**
   * Set the button as disabled; Vale solo per i bottoni
   */
  @Prop() disabled: boolean = false;

  /**
   * Indicates the variant of the button
   */
  @Prop() variant: 'primary'|'secondary'|'white'|'neutral' = 'primary';

  /**
   * Indicates the button as outline
   */
  @Prop() outline: boolean = false;

  /**
   * Indicates the size of the button
   */
  @Prop() size: string = 'medium';

  /**
   * Indicates if the button is full width
   */
  @Prop() full: boolean = false;

  /**
   * Indicates the button as pill
   */
  @Prop() pill: boolean = false;

  /**
    * Indicates the button as text
   */
  @Prop() text: boolean = false;

  /**
   * Indicates the button as only icon
   **/
  @Prop() onlyIcon: boolean = false;

  /**
   * Indicates if button becames a anchor
   **/
  @Prop() href: string;

  /**
   * Indicates the type of anchor's target 
   **/
  @Prop() target: '_blank' | '_parent' | '_self' | '_top'

  /**
   * Indicates type button
   **/
  @Prop() type: 'button'|'submit'|'reset' = 'button';

  /**
   * Indicates the name that the sender button will send
   **/
  @Prop() name: string = undefined;

  /**
   * Indicates the value that the sender button will send
   **/
  @Prop() value: string = undefined;

  /**
   * Indicates the value of text alternative to an element that has no visible text on the screen
   **/
  @Prop() ariaLabel: string = undefined;

  /**
   * Indicates classes of the component
   **/
  @Prop() class: string = undefined;

  /**
   * Indicates classes of the component
   **/
  @Prop() buttonId: string = undefined;

  componentWillLoad() {
    this.target = this.href ? this.target : '_self';
  }

  render() {
    
    return (
      <Host>
        {this.href ? (
          <a href={this.href} id={this.buttonId} class={this.class} data-variant={this.variant} data-outline={this.outline} data-size={this.size} data-full={this.full} data-pill={this.pill} data-text={this.text} data-only-icon={this.onlyIcon} aria-label={this.ariaLabel} target={this.target}>
            <slot name="prefix"></slot>
            {!this.onlyIcon && <slot></slot>}
            <slot name="suffix"></slot>
          </a>
        ) : ( 
          <button id={this.buttonId} class={this.class} data-variant={this.variant} data-outline={this.outline} data-size={this.size} data-full={this.full} data-pill={this.pill} data-text={this.text} data-only-icon={this.onlyIcon} disabled={this.disabled} aria-label={this.ariaLabel} type={this.type} name={this.name} value={this.value}>
            <slot name="prefix"></slot>
            {!this.onlyIcon && <slot></slot> }
            <slot name="suffix"></slot>
          </button>
        )}
      </Host>
    );
  }

}
